import type { Form } from '../../interfaces/form.interface';
import {
    ReactiveModalFormCoordinator,
    type ReactiveModalFormCoordinatorConfig,
} from './reactive-modal-form-coordinator';

export type ReactiveListModalDefinitionFactoryConfig<TModel> = ReactiveModalFormCoordinatorConfig<TModel>;

/** Public alias for list-modal form definitions that should not know modal defaults. */
export class ReactiveListModalDefinitionFactory {
    public static create<TModel>(config: ReactiveListModalDefinitionFactoryConfig<TModel>): Form<TModel> {
        return ReactiveModalFormCoordinator.createForm(config);
    }
}
